import { useMsal } from '@azure/msal-react';
import LogoutIcon from '@mui/icons-material/Logout';
import { Menu, MenuItem, MenuProps } from '@mui/material';
import React from 'react';
import { useNavigate } from 'react-router';
import { localAuth, logoutWithoutRedirect } from '../../../../lib/api/auth';

const AccountDropdown = (props: MenuProps) => {
    const nav = useNavigate();
    const { instance } = useMsal();

    const onClickLogout = async () => {
        await logoutWithoutRedirect(instance);

        localAuth.logout();

        nav('/login');
    };

    return (
        <Menu sx={{ marginTop: 1, ...props.sx }} {...props}>
            <MenuItem onClick={onClickLogout}>
                <LogoutIcon /> Logout
            </MenuItem>
        </Menu>
    );
};

export default AccountDropdown;
